//libs
import React, { memo } from 'react';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

//styles
import { Title, Container, UpArrowWrapper, RightArrowWrapper, Count, Wrapper } from './styles';

//defs
interface ICollapsedFilter {
  title: string;
  isCollapsedView: boolean;
  onArrowClick: () => void;
  selectedFiltersCount?: number;
  isOverlayFilter?: boolean;
}

const ARROW_SIZE = '20px';

function CollapsedFilter({
  title,
  isCollapsedView,
  onArrowClick,
  selectedFiltersCount = 0,
  isOverlayFilter,
}: ICollapsedFilter) {
  // Get store-aware icon
  const ChevronDownSmall = useStoreIcon(IconName.CHEVRON_DOWN_SMALL);

  return (
    <Container onClick={onArrowClick}>
      <Title isCollapsedView={isCollapsedView}>{title}</Title>
      <Wrapper>
        {selectedFiltersCount > 0 && <Count>{selectedFiltersCount}</Count>}
        {isCollapsedView ? (
          <ChevronDownSmall size={ARROW_SIZE} />
        ) : isOverlayFilter ? (
          <RightArrowWrapper>
            <ChevronDownSmall size={ARROW_SIZE} />
          </RightArrowWrapper>
        ) : (
          <UpArrowWrapper>
            <ChevronDownSmall size={ARROW_SIZE} />
          </UpArrowWrapper>
        )}
      </Wrapper>
    </Container>
  );
}

export default memo(CollapsedFilter);
